import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import PaperDraggable from "../../../../../../../../../components/PaperDraggable";
import { useMemo, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { headCellsRecbCompensacao } from "../../../../../../MIContasReceber/dataGridConfig";
import { Moment } from "moment";
import { TableDataGridRef, TableDataGridV2 } from "../../../../../../../../../components/TableDataGridV2";
import { IDataListaTitulosReceber } from "../../../../../../../../../types/api/financeiro/pesquisar-titulos-receber";
import { enqueueSnackbar } from "notistack";
import { IDataPublicos } from "../../../../../../../../../types/api/geral/pesquisar-publicos";
import SelectPublico from "../../../../../../../../../components/SelectsSimpleApiQuery/SelectPublico";

export default function DialogCadastrarCompensacao({
    open,
    selected,
    liquidarTerceiros,
    handleChangeSelected,
    handleClose
}: DialogCadastrarCompensacaoProps) {


    const { getValues } = useFormContext();
    const tableRef = useRef<TableDataGridRef<IDataListaTitulosReceber>>(null)

    const [publico, setPublico] = useState<IDataPublicos | null>(null);

    const dataPagamento: Moment = getValues('finalizacao.data_pagamento')
    const containerRef = useRef<HTMLDivElement>(null);
    const primeiroTitulo = getValues("selecionar_titulos")[0];
    const pesquisaPublico = useMemo(() => {
            if (liquidarTerceiros && publico) {
                return {
                    tipo_publico_contem: [publico.tipo_publico],
                    codigo_publico_contem: [publico.codigo_publico]
                }
            }
            return {
                    tipo_publico_contem: [primeiroTitulo.tipo_publico],
                    codigo_publico_contem: [primeiroTitulo.codigo_publico]
                }
        }, [primeiroTitulo, liquidarTerceiros, publico]);
    const handleSubmit = () => {
        const selecionados = tableRef.current?.getSelectedRows() || []
        if (selecionados.length === 0) {
            enqueueSnackbar('Por favor, selecione pelo menos um título', { variant: 'warning' })
            return
        }
        handleChangeSelected(selecionados);
        handleClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            scroll="body"
            maxWidth="md"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Selecione os títulos a receber
            </DialogTitle>

            <DialogContent>
                 {
                    liquidarTerceiros &&
                    <Grid container my={2}>
                        <SelectPublico
                            value={publico}
                            onChange={(data) => setPublico(data)}
                        />
                    </Grid>
                }
                <Box ref={containerRef}>
                    <TableDataGridV2
                        ref={tableRef}
                        enableSelection
                        columns={headCellsRecbCompensacao}
                        url="financeiro/contas-receber/pesquisar-titulos-receber"
                        queryKey="pesquisar-titulos-receber-compensacao"
                        pagination="server"
                        queryParams={{
                            ...pesquisaPublico,
                            saldo_principal_maior_igual: 1,
                            data_recebimento_is_null: true,
                            data_simulacao_calculo: dataPagamento.format('YYYY-MM-DD')
                        }}
                        selectedFields={['id', 'saldo_simulado', 'data_vencimento', 'data_emissao']}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Selecionar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

interface DialogCadastrarCompensacaoProps {
    open: boolean;
    selected: IDataListaTitulosReceber[];
    liquidarTerceiros: boolean;
    handleChangeSelected: (arg: IDataListaTitulosReceber[]) => void;
    handleClose: () => void;
}
